// Currency choices follow the organisation, not the client's residence or nationality.
export function sowCurrenciesForJurisdiction(jurisdiction) {
  const geo = String(jurisdiction ?? "").trim().toLowerCase();
  return ["USD", ["switzerland", "ch", "che"].includes(geo) ? "CHF" : "AED"];
}
